import React from 'react';
import PropTypes from 'prop-types';
import url from 'url';

import isUserAgentMobileApp from 'common/util/isUserAgentMobileApp';

import sendDataToMobileApp, {
  SR_MOBILE_APP_ACTION_TYPE_OPEN_URL,
} from 'client/helpers/sendDataToMobileApp';

import SrButton, {
  SR_BUTTON_THEME_ADOBE_YELLOW,
} from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';
import SrFormikErrorMessage from 'client/components/SrFormikErrorMessage';

import './SrSunSetupDriverJobPage.less';

const SrSunSetupDriverJobCodeboxTest = ({
  userAgent,
  listing,
  formikBag,
  appUrl,
}) => {
  return (
    <div styleName='card' className='fieldsContainer' id='field-successfulTest'>
      <span styleName='cardTitle'>
        CodeBox Check
      </span>

      <SrBox margin='16px 0 0'>
        <SrButton
          theme={SR_BUTTON_THEME_ADOBE_YELLOW}
          hasBoxShadow
          onClick={() => {
            const link = url.resolve(appUrl, `/listing/${listing.id}`);
            const isMobileApp = isUserAgentMobileApp(userAgent);

            event.preventDefault();

            if (isMobileApp) {
              sendDataToMobileApp({
                actionType: SR_MOBILE_APP_ACTION_TYPE_OPEN_URL,
                url: link,
              });
            }
            else {
              global.open(link, '_blank');
            }
          }}
        >
          Self-Tour
        </SrButton>
      </SrBox>
      <SrBox position='relative'>
        <SrFormikErrorMessage
          id='successfulTest'
          formikBag={formikBag}
        />
      </SrBox>
    </div>
  );
};

SrSunSetupDriverJobCodeboxTest.propTypes = {
  userAgent: PropTypes.object.isRequired,
  listing: PropTypes.object.isRequired,
  formikBag: PropTypes.object.isRequired,
  appUrl: PropTypes.string.isRequired,
};

SrSunSetupDriverJobCodeboxTest.displayName = 'SrSunSetupDriverJobCodeboxTest';

export default SrSunSetupDriverJobCodeboxTest;
